import React, { ReactNode } from 'react';

import './EmptySectionState.scss';

type Props = {
  children: ReactNode;
};

function EmptySectionState({ children }: Props) {
  return <div className="empty-section-state text-center text-muted p-3">{children}</div>;
}

export default EmptySectionState;
